import React from 'react'
import ButtonBlock from './ButtonBlock'
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

const TwoColumnGridContent = (data) => {
  const { columnGridContent: { left, right } } = data;

  return (
    <div className="two-column-grid-section">
      <div className="two-column-images">
        <div className="image-column left">
          <div>
            <GatsbyImage
              image={getImage(left.image)}
              alt={left.title}
              objectFit="contain"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        </div>
        <div className="image-column right">
          <div>
            <GatsbyImage
              image={getImage(right.image)}
              alt={right.title}
              objectFit="contain"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        </div>
      </div>
      <div className="two-column-grid">
        <div className="grid-column left">
          <div className="column-content">
            <p>{left.title}</p>
            <ButtonBlock
              text={left.buttonText}
              link={left.buttonUrl}
              className="dark"
            />
          </div>
        </div>
        <div className="grid-column right">
          <div className="column-content">
            <p>{right.title}</p>
            <ButtonBlock
              text={right.buttonText}
              link={right.buttonUrl}
              className="dark"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default TwoColumnGridContent